import { render, staticRenderFns } from "./the.vue?vue&type=template&id=671e2cf3&"
import script from "./the.vue?vue&type=script&lang=ts&"
export * from "./the.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports